import React from 'react'
import Studentquiz from '../../components/student/studentquiz'
export default function Quiz() {
  return (
    <div>
        <Studentquiz/>
    </div>
  )
}
